import { isLinkActive } from '@/app/layouts/AsideMenu';
import { MANAGEMENT_REPORTS_ITEMS, MANAGEMENT_REPORTS_LABEL, MANAGEMENT_REPORTS_SECONDARY } from './menuItems';
import { SectionNav } from './SectionNav';

/** True on the screens of the Management Reports section (APT375), Dimensions included. */
export const isManagementReportsRoute = (pathname: string): boolean =>
  [...MANAGEMENT_REPORTS_ITEMS, ...MANAGEMENT_REPORTS_SECONDARY].some((i) => isLinkActive(pathname, i.to));

/**
 * APT375 (client): "On selecting Management Reports, display the following options in the top row/grid, consistent with the navigation pattern
 * used across the module: Management Periods, Periodic Trial Balance, Budgets, Management Packs. Dimensions should be available as a smaller
 * Settings/Configuration option within the Management Reports screen rather than appearing as a main report option."
 */
export const ManagementReportsNav = () => (
  <SectionNav
    label={MANAGEMENT_REPORTS_LABEL}
    items={MANAGEMENT_REPORTS_ITEMS}
    secondaryItems={MANAGEMENT_REPORTS_SECONDARY}
    testId="management-reports-nav"
  />
);
